import {
  Button,
  Locale,
  Dropdown,
  Breadcrumb,
  Menu,
  Row,
  Table,
  Input,
  Form,
  Loading,
  Message,
  Pagination,
  Select,
  Dialog,
  Switch,
  RadioGroup,
  Radio,
  Upload,
  MessageBox,
  InputNumber,
  DatePicker,
  Tag,
  Tabs,
  Cascader,
  Tree,
  Checkbox,
  /* eslint-disable no-unused-vars */
  Style
} from '@zoom/zoom-ui'

import Vue from 'vue'

Vue.use(Button)
Vue.use(Locale)
Vue.use(Dropdown)
Vue.use(Breadcrumb)
Vue.use(Menu)
Vue.use(Row)
Vue.use(Table)
Vue.use(Input)
Vue.use(Form)
Vue.use(Loading)
Vue.use(Message)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Upload)
Vue.use(MessageBox)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Tabs)
Vue.use(Cascader)
Vue.use(Tree)
Vue.use(Checkbox)
